/* Copyright (c) Trimble Inc. All rights reserved. */
import { InputContainer } from "modus/components/form/input-container/InputContainer";
import React from "react";
import { NotificationActionsProps } from "./TeamNotificationActions";
import { useSelector } from "react-redux";
import { useCurrentTeam } from "libs/security/authorization/Permission";

export const SubscriptionNotificationForm: React.FC<
  NotificationActionsProps
> = ({ notification }) => {
  const { teamName: storedTeamName } = useCurrentTeam();
  const teamName = useSelector((state: any) =>state?.teamManager?.teams?.currentTeam?.name ??storedTeamName);

  return (
    <>
      
      {notification?.resource?.verificationInfo?.applicationName  && (<InputContainer
        label={"Application Name"}
        value={notification?.resource?.verificationInfo?.applicationName}
        name={"applicationName"}
        disabled={true}
      />)}
      {notification?.resource?.verificationInfo?.productName  && (<InputContainer
        label={"Product Name"}
        value={notification?.resource?.verificationInfo?.productName}
        name={"productName"}
        disabled={true}
      />)}
      <InputContainer
        label={"Requester Email"}
        value={notification?.requestedBy?.emailAddress}
        name={"email"}
        disabled={true}
      />
      {notification?.requestedBy?.accountName  && (<InputContainer
        label={"Account"}
        value={notification?.requestedBy?.accountName }
        name={"account"}
        disabled={true}
      />)}
    </>
  );
};

export default SubscriptionNotificationForm;
